export default __webpack_public_path__ + "static/media/icons8-google-cloud-platform.24d40447.svg";